export const commonStatuses = {
    none: "NONE",
    logining: "LOGINING",
    loged: "LOGED",
    loading: "LOADING",
    loaded: "LOADED",
    failed: "FAILED",
    saving: "SAVING",
    saved: "SAVED",
    uploading: "UPLOADING",
    uploaded: "UPLOADED",
    available: "AVAILABLE",
    notAvailable: "NOT_AVAILABLE"
};

export const commonStatusesDescriptions = {
    [commonStatuses.none]: "----",
    [commonStatuses.logining]: "logining ...",
    [commonStatuses.loged]: "loged",
    [commonStatuses.loading]: "Loading...",
    [commonStatuses.loaded]: "Loaded",
    [commonStatuses.failed]: "Loading collection Failed!",
    [commonStatuses.saving]: "Saving information...",
    [commonStatuses.saved]: "Saved successfully!",
    [commonStatuses.uploading]: "Uploading...",
    [commonStatuses.uploaded]: "Uploaded successfully!",
    [commonStatuses.available]: "Available",
    [commonStatuses.notAvailable]: "Not available"
};